import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const VenezuelaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16218'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16218)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#063191'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#E2213B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99935 6.53331C10.2623 6.53331 10.4755 6.32438 10.4755 6.06664C10.4755 5.80891 10.2623 5.59998 9.99935 5.59998C9.73636 5.59998 9.52316 5.80891 9.52316 6.06664C9.52316 6.32438 9.73636 6.53331 9.99935 6.53331ZM8.09459 6.99998C8.35758 6.99998 8.57078 6.79104 8.57078 6.53331C8.57078 6.27558 8.35758 6.06664 8.09459 6.06664C7.83159 6.06664 7.6184 6.27558 7.6184 6.53331C7.6184 6.79104 7.83159 6.99998 8.09459 6.99998ZM12.3803 6.53331C12.3803 6.79104 12.1671 6.99998 11.9041 6.99998C11.6411 6.99998 11.4279 6.79104 11.4279 6.53331C11.4279 6.27558 11.6411 6.06664 11.9041 6.06664C12.1671 6.06664 12.3803 6.27558 12.3803 6.53331ZM7.14221 8.39998C7.4052 8.39998 7.6184 8.19104 7.6184 7.93331C7.6184 7.67558 7.4052 7.46664 7.14221 7.46664C6.87921 7.46664 6.66602 7.67558 6.66602 7.93331C6.66602 8.19104 6.87921 8.39998 7.14221 8.39998ZM13.3327 7.93331C13.3327 8.19104 13.1195 8.39998 12.8565 8.39998C12.5935 8.39998 12.3803 8.19104 12.3803 7.93331C12.3803 7.67558 12.5935 7.46664 12.8565 7.46664C13.1195 7.46664 13.3327 7.67558 13.3327 7.93331Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#FFD044'
				/>
			</g>
		</svg>
	);
};

export default VenezuelaFlagIcon;
